import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { QUICK_ACTIONS } from "./constants";

export default function AIQuickActions({ onSelect, disabled, visible, actions }) {
  if (!visible) return null;
  const list = Array.isArray(actions) && actions.length ? actions : QUICK_ACTIONS;

  return (
    <Box
      sx={{
        px: 2,
        pb: 1,
        display: "flex",
        flexWrap: "wrap",
        gap: 0.8,
        bgcolor: "#ffffff",
      }}
    >
      {list.map((action) => (
        <Chip
          key={action.id}
          label={action.label}
          size="small"
          clickable={!disabled}
          disabled={disabled}
          onClick={() => onSelect(action.prompt || action.label)}
          sx={{
            borderRadius: 2,
            bgcolor: "#eff6ff",
            color: "#1e3a8a",
            fontWeight: 600,
            border: "1px solid rgba(0, 97, 254, 0.18)",
            "&:hover": { bgcolor: "#dbeafe" },
          }}
        />
      ))}
    </Box>
  );
}

AIQuickActions.propTypes = {
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  visible: PropTypes.bool,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      prompt: PropTypes.string,
    })
  ),
};
